import DOMPurify from "dompurify";

/** HTML-safe for display (matches email thread sanitization). */
export function sanitizeDisplayHtml(html: string): string {
  if (!html) return html;
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
